// @noflow
import { getDataId, getIsSavingSchedule, getScheduleData, getScheduleType } from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import { getDefaultSchedule } from './schedule-type';
import { getPropsForProduct } from '~/core/state/products/selectors';
import { resetSchedule } from '~/core/state/ui/schedule/actions';
import Schedule from './component';

const mapStateToProps = (state, ownProps) => {
    const isScheduleLoaded = getScheduleData(state, ownProps) != null;
    const isSavingSchedule = getIsSavingSchedule(state, ownProps);
    const scheduleType = getScheduleType(state, ownProps);
    const productId = getDataId(state, ownProps);
    const productProps = getPropsForProduct(state, { id: productId });

    return {
        ...ownProps,
        isSavingSchedule,
        productId,
        isScheduleLoaded,
        productProps,
        scheduleType
    };
};

const mapDispatchToProps = { resetSchedule };

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { productProps, scheduleType } = stateProps;
    const { resetSchedule } = dispatchProps;
    const { componentId } = ownProps;

    const reset = () => {
        const defaultSchedule = getDefaultSchedule({
            type: scheduleType,
            productProps
        });
        if (defaultSchedule) {
            resetSchedule({ componentId, defaultSchedule });
        }
    };

    return {
        ...ownProps,
        ...stateProps,
        reset
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Schedule);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/index.js